// extracted by mini-css-extract-plugin
module.exports = {"base":"Select_base__RE_Lc","error":"Select_error__710lS","isDisabled":"Select_isDisabled__x5Zn1","required":"Select_required__lrxiV"};